import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Result } from '../../shared/models/core/result.model';
import { User } from '../../shared/models/user.model';

@Injectable({
    providedIn: 'root'
})
export class UserManagementService {
    private baseUrl = `${environment.apiUrl}/users`;
    private http$ = inject(HttpClient);

    findUsers(page: number = 1, size: number = 10, keywords: string = ''): Observable<Result<User>> {
        let params = new HttpParams()
            .set('page', page)
            .set('size', size);

        if (keywords) {
            params = params.set('keywords', keywords);
        }

        return this.http$.get<Result<User>>(this.baseUrl, { params });
    }

    getUserById(id: number | string): Observable<User> {
        return this.http$.get<User>(`${this.baseUrl}/${id}`);
    }

    createUser(user: User): Observable<User> {
        return this.http$.post<User>(this.baseUrl, user);
    }

    updateUser(id: number | string, user: Partial<User>): Observable<User> {
        return this.http$.put<User>(`${this.baseUrl}/${id}`, user);
    }

    deleteUser(id: number | string): Observable<User> {
        return this.http$.delete<User>(`${this.baseUrl}/${id}`);
    }
}
